import {Outlet} from "react-router-dom"
import Main from "./Main"

export default function StationLayout() {
    return (
        <>
            <Main>
                <Outlet/>
            </Main>
        </>
    )
}